import { DatePipe } from '@angular/common';
import { IMasterDetailTableConfig } from '../models/master-detail-config.model';

const datePipe = new DatePipe('en-US')

export const MASTER_DETAIL_TABLE_CONFIGS: { [key: string]: IMasterDetailTableConfig } = {
    'court-divisions-case-types': {
        pageTitle: 'Court Divisions Case Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Court Divisions Case Types' }],
        searchFields: [
            { key: 'courtUnitTypeId', label: 'Court Division ID', type: 'number' },
            { key: 'id', label: 'Case Type ID', type: 'number' }
        ],
        masterTable: {
            panelTitle: 'Court Divisions',
            detailDataKey: 'caseTypesData',
            columns: [
                {
                    key: 'courtUnitTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'court-unit-types/fetch-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'courtUnitTypeId',
                    endpointLabelKey: 'courtUnitTypeId,courtUnitTypeName',
                    dependents: [
                        { sourceProperty: 'courtUnitTypeName', targetKey: 'courtUnitTypeName' }
                    ]
                },
                { key: 'courtUnitTypeName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Case Types',
            columns: [
                {
                    key: 'id', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'case-types/fetch.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'id,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'name' }
                    ]
                },
                { key: 'name', label: 'Name', type: 'text', isEditable: false, },
            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttcourt-unittypes-appealtype/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttcourt-unittypes-appealtype/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttcourt-unittypes-appealtype/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {
                // Combine and return the array of inserts and updates
                return [...newRecords, ...modifiedRecords];
            },
            deleteMaster: (deletedRecords: any[]) => {

                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    courtUnitTypeId: record.courtUnitTypeId,
                    courtUnitTypeName: record.courtUnitTypeName,
                    transType: '',
                    id: record.caseTypesData.length === 1 ? record.caseTypesData[0].id : ''
                }));
            }
        }
    },
    'case-types-document-types': {
        pageTitle: 'Case Types Document Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Case Types Document Types' }],
        searchFields: [
            { key: 'caseTypesId', label: 'Court Type ID', type: 'number' },
            { key: 'docTypeId', label: 'Document Type ID', type: 'number' }
        ],
        masterTable: {
            panelTitle: 'Case Types',
            detailDataKey: 'docTypesData',
            detailDataRequired: true,
            columns: [
                {
                    key: 'caseTypesId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'case-types/fetch.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'id,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'caseTypesName' }
                    ]
                },
                { key: 'caseTypesName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Document Types',
            columns: [
                {
                    key: 'docTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'document-types/fetch-doc-types.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'docTypeId',
                    endpointLabelKey: 'docTypeId,docTypeName',
                    dependents: [
                        { sourceProperty: 'docTypeName', targetKey: 'docTypeName' }
                    ]
                },
                { key: 'docTypeName', label: 'Name', type: 'text', isEditable: false, },
                {
                    key: 'mandatory', label: 'Mandatory Document', type: 'select', isEditable: true, required: true, options: [{ label: 'Y', value: 'Y' },
                    { label: 'N', value: 'N' }]
                },
                {
                    key: 'checklistFlag', label: 'Checklist Document', type: 'select', isEditable: true, required: true, options: [{ label: 'Y', value: 'Y' },
                    { label: 'N', value: 'N' }]
                },


            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttcasetypes-doctypes/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttcasetypes-doctypes/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttcasetypes-doctypes/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                return [...newRecords, ...modifiedRecords];
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    caseTypesId: record.caseTypesId,
                    caseTypesName: record.caseTypesName,
                    transType: '',
                    docTypeId: record.docTypesData.length === 1 ? record.docTypesData[0].docTypeId : null
                }));
            }
        }
    },
    'event-types-task-types-roles': {
        pageTitle: 'Event Types Task Types Roles',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Event Types Task Types Roles' }],
        searchFields: [
            { key: 'eventTypeId', label: 'Event Type ID', type: 'number' },
            { key: 'taskId', label: 'Task Type ID', type: 'number' },
            { key: 'intRoleId', label: 'Role ID', type: 'number' },
        ],
        masterTable: {
            panelTitle: 'Event Types',
            detailDataKey: 'taskTypesData',
            columns: [
                {
                    key: 'eventTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'eventtypes/fetch-event-types-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'id,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'eventTypeName' }
                    ]
                },
                { key: 'eventTypeName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Task Types',
            childDetailDataKey: 'roleDetailsData', // <--- Specifies the array property for the 3rd tier data
            columns: [
                {
                    key: 'taskId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'tasktypes/fetch/task-types-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'taskId',
                    endpointLabelKey: 'taskId,taskName,category',
                    dependents: [
                        { sourceProperty: 'taskName', targetKey: 'taskName' },
                        { sourceProperty: 'category', targetKey: 'category' }
                    ]
                },
                { key: 'taskName', label: 'Name', type: 'text', isEditable: false, },
                { key: 'category', label: 'Category', type: 'text', isEditable: false, },
                { key: 'sequence', label: 'Sequence', type: 'number', isEditable: true, required: true },
            ],
            actions: {
                showAdd: true,
            }
        },
        childDetailTable: {
            panelTitle: 'Roles',
            columns: [
                {
                    key: 'intRoleId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'ttRole-dtls/fetch/roles-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'intRoleId',
                    endpointLabelKey: 'intRoleId,roleName',
                    dependents: [
                        { sourceProperty: 'roleName', targetKey: 'roleName' },
                    ]
                },
                { key: 'roleName', label: 'Name', type: 'text', isEditable: false, },
            ],
            actions: {
                showAdd: true,

            }
        },
        apiEndpoints: {
            search: 'tteventtypes-tasktypes-roles/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'tteventtypes-tasktypes-roles/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'tteventtypes-tasktypes-roles/delete.htm',
            deleteMasterMethod: 'POST',

        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },

            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {
                // Combine and return the array of inserts and updates
                return [...newRecords, ...modifiedRecords];
            },

            deleteMaster: (deletedRecords: any[], selectedDetailRows?: any[], selectedChildDetailRows?: any[]) => {
                const hasSelectedChildRole = selectedChildDetailRows && selectedChildDetailRows.length > 0;
                const hasSelectedDetailTask = selectedDetailRows && selectedDetailRows.length > 0;
                return deletedRecords.map(record => {
                    const selectedTask = hasSelectedDetailTask ? selectedDetailRows[0] : (hasSelectedChildRole ? record.taskTypesData?.[0] : null);
                    const selectedRole = hasSelectedChildRole ? selectedChildDetailRows[0] : null;

                    return {
                        eventTypeId: record.eventTypeId ?? null,
                        eventTypeName: record.eventTypeName ?? '',
                        transType: '',
                        taskId: selectedTask ? (selectedTask.taskId ?? '') : '',
                        intRoleId: selectedRole ? (selectedRole.intRoleId ?? '') : '',
                        sequence: selectedTask ? (selectedTask.sequence ?? '') : ''
                    };
                });
            }
        }
    },
    'document-types-case-phase-types': {
        pageTitle: 'Document Types Case Phase Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Document Types Case Phase Types' }],
        searchFields: [
            { key: 'docTypeId', label: 'Document Type ID', type: 'text' },
            { key: 'appealPhaseTypeId', label: 'Case PhaseType ID', type: 'text' }
        ],
        masterTable: {
            panelTitle: 'Document Types',
            detailDataKey: 'appealPhTypesData',
            columns: [
                {
                    key: 'docTypeId', label: 'Document Type ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'document-types/fetch-doc-types.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'docTypeId',
                    endpointLabelKey: 'docTypeId,docTypeName',
                    dependents: [
                        { sourceProperty: 'docTypeName', targetKey: 'docTypeName' }
                    ]
                },
                { key: 'docTypeName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Case Phase Types',
            columns: [
                {
                    key: 'casePhTypesId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'casephtypes/search.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'casePhTypesId',
                    endpointLabelKey: 'casePhTypesId,casePhTypesName',
                    dependents: [
                        { sourceProperty: 'casePhTypesName', targetKey: 'casePhTypesName' }
                    ]
                },
                { key: 'casePhTypesName', label: 'Name', type: 'text', isEditable: false, },


            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttdoctype-casephtype/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttdoctype-casephtype/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttdoctype-casephtype/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                // Combine new + filtered modified records
                const payload = [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I'   // change value here
                }));

                return payload
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    transType: '',
                    docTypeId: record.docTypeId,
                    docTypeName: record.docTypeName,
                    appealPhaseTypeId: deletedRecords[0].appealPhTypesData.length === 1 ? deletedRecords[0].appealPhTypesData[0].casePhTypesId : ''
                }));
            }
        }
    },
    'case-status-case-phase-types': {
        pageTitle: 'Case Status Case phase Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Case Status Case phase Types' }],
        searchFields: [
            { key: 'appealStatusId', label: 'Case Status ID', type: 'number' },
            { key: 'casePhTypesId', label: 'Case Stage', type: 'number' }
        ],
        masterTable: {
            panelTitle: 'Case Status',
            detailDataKey: 'appealPhTypesData',
            detailDataRequired: true,
            columns: [
                {
                    key: 'appealStatusId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'case-status/fetch.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'caseStatusId',
                    endpointLabelKey: 'caseStatusId,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'appealStatusName' }
                    ]
                },
                { key: 'appealStatusName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Case Phase Types',
            columns: [
                {
                    key: 'casePhTypesId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'casephtypes/search.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'casePhTypesId',
                    endpointLabelKey: 'casePhTypesId,casePhTypesName',
                    dependents: [
                        { sourceProperty: 'casePhTypesName', targetKey: 'casePhTypesName' }
                    ]
                },
                { key: 'casePhTypesName', label: 'Name', type: 'text', isEditable: false, },


            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttappealstatus-appealphtype/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttappealstatus-appealphtype/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttappealstatus-appealphtype/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                // Combine new + filtered modified records
                return [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I'   // change value here
                }));
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                const payoad = [{
                    appealStatusId: deletedRecords[0].appealStatusId,
                    appealStatusName: deletedRecords[0].appealStatusName,
                    casePhTypesId: deletedRecords[0].appealPhTypesData[0].casePhTypesId,
                    transType: ''
                }];
                return payoad;

            }
        }
    },
    'staff-roles-document-types': {
        pageTitle: 'Staff Roles Document Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Staff Roles Document Types' }],
        searchFields: [
            { key: 'roleId', label: 'Role ID', type: 'number' },
            { key: 'docTypeId', label: 'Document Type ID', type: 'number' },
        ],
        masterTable: {
            panelTitle: 'Staff Roles',
            detailDataKey: 'childDcTypeData',
            columns: [
                {
                    key: 'roleId', label: 'Role ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'ttRole-dtls/fetch/roles-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'intRoleId',
                    endpointLabelKey: 'intRoleId,roleName',
                    dependents: [
                        { sourceProperty: 'roleName', targetKey: 'roleName' }
                    ]
                },
                { key: 'roleName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Document Types',
            columns: [
                {
                    key: 'docTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'document-types/fetch-doc-types.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'docTypeId',
                    endpointLabelKey: 'docTypeId,docTypeName',
                    dependents: [
                        { sourceProperty: 'docTypeName', targetKey: 'docTypeName' }
                    ]
                },
                { key: 'docTypeName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'doctype-roles/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'doctype-roles/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'doctype-roles/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {


                // Combine new + filtered modified records
                return [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I'   // change value here
                }));;
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    ...record,
                    transType: '',
                    docTypeId: deletedRecords[0].childDcTypeData.length === 1 ? deletedRecords[0].childDcTypeData[0].docTypeId : ''
                }));
            }
        }
    },
    'party-roles-document-types': {
        pageTitle: 'Party Roles Document Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Party Roles Document Types' }],
        searchFields: [
            { key: 'partyRoleId', label: 'Party Role ID', type: 'number' },
            { key: 'docTypeId', label: 'Document Type ID', type: 'number' },
        ],
        masterTable: {
            panelTitle: 'Party Roles',
            detailDataKey: 'docTypesData',
            columns: [
                {
                    key: 'partyRoleId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'party-roles/fecth-mapping.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'partyRoleId',
                    endpointLabelKey: 'partyRoleId,partyRoleName',
                    dependents: [
                        { sourceProperty: 'partyRoleName', targetKey: 'partyRoleName' },
                        { sourceProperty: 'partyRoleDesc', targetKey: 'partyRoleDesc' }
                    ]
                },
                { key: 'partyRoleName', label: 'Name', type: 'text', isEditable: false },
                { key: 'partyRoleDesc', label: 'Description', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Document Types',
            columns: [
                {
                    key: 'documentTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'document-types/fetch-fee-assessment-docs.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'docTypeId',
                    endpointLabelKey: 'docTypeId,docTypeName',
                    dependents: [
                        { sourceProperty: 'docTypeName', targetKey: 'documentTypeName' }
                    ]
                },
                { key: 'documentTypeName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttpartyroles-documenttypes/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttpartyroles-documenttypes/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttpartyroles-documenttypes/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {
                // remove records with trnsType = 'U'


                // Combine new + filtered modified records
                return [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I'   // change value here
                }));
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    partyRoleId: record.partyRoleId,
                    partyRoleName: record.partyRoleName,
                    partyRoleDesc: record.partyRoleDesc,
                    transType: '',
                    documentTypeId: record.docTypesData.length === 1 ? deletedRecords[0].docTypesData[0].documentTypeId : ''
                }));
            }
        }
    },
    'task-types-event-types': {
        pageTitle: 'Task Types Event Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Task Types Event Types' }],
        searchFields: [
            { key: 'taskTypeId', label: 'Task Type ID', type: 'number' },
            { key: 'eventTypeId', label: 'Event Type ID', type: 'number' },
        ],
        masterTable: {
            panelTitle: 'Task Types',
            detailDataKey: 'eventTypesDataForTasks',
            columns: [
                {
                    key: 'taskTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'tasktypes/fetch/task-types-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'taskId',
                    endpointLabelKey: 'taskId,taskName,category',
                    dependents: [
                        { sourceProperty: 'taskName', targetKey: 'taskName' },
                    ]
                },
                { key: 'taskName', label: 'Name', type: 'text', isEditable: false },
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Event Types',
            columns: [
                {
                    key: 'eventTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'eventtypes/fetch-event-types-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'id,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'eventName' }
                    ]
                },
                { key: 'eventName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'tttask-eventtypes/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'tttask-eventtypes/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'tttask-eventtypes/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                // Combine new + filtered modified records
                return [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I', // change value here
                }));;
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    taskTypeId: record.taskTypeId,
                    taskName: record.taskName,
                    transType: "",
                    eventTypeId: record.eventTypesDataForTasks.length === 1 ? record.eventTypesDataForTasks[0].eventTypeId : ''
                }));
            }
        }
    },
    'court-divisions': {
        pageTitle: 'Court Divisions',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Court Divisions' }],
        searchFields: [
            { key: 'cutName', label: 'Name', type: 'text' },
        ],
        masterTable: {
            panelTitle: 'Court Divisions',
            detailDataKey: 'childCourtDivisionData',
            detailDataRequired: false,
            columns: [
                { key: 'cutName', label: 'Name', type: 'text', isEditable: true, required: true, editableOnModify: false },
                { key: 'shortName', label: 'Short Name', type: 'text', isEditable: true, required: true, editableOnModify: false },
                { key: 'desc', label: 'Description', type: 'text', isEditable: true, editableOnModify: true }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showModify: true
            }
        },
        detailTable: {
            panelTitle: 'Courts',
            columns: [
                { key: 'crtDivName', label: 'Name', type: 'text', isEditable: false, editableOnModify: false },
                { key: 'crtDivDesc', label: 'Description', type: 'text', isEditable: true, editableOnModify: true },
                {
                    key: 'crtDivActiveFlag', label: 'Active', type: 'select', isEditable: true, options: [{ label: 'Y', value: 'Y' },
                    { label: 'N', value: 'N' }], editableOnModify: true
                },
                {
                    key: 'ftmFlag', label: 'Fast Track Motion', type: 'select', isEditable: true, options: [{ label: 'Y', value: 'Y' },
                    { label: 'N', value: 'N' }], editableOnModify: true
                }
            ],
            actions: {
                showAdd: true,
                showModify: true
            }
        },
        apiEndpoints: {
            search: 'court-unit-types/search/all.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            updateMaster: 'court-unit-types/upsert.htm?transType=U',
            updateMasterMethod: 'POST',
            saveMaster: 'court-unit-types/upsert.htm?transType=I',
            saveMasterMethod: 'POST',
        },
        payloadBuilders: {
            search: (formValue: any) => {
                const payload: any = {
                    cutId: "",
                    cutName: formValue.cutName,
                    isMaster: true
                };

                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });

                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                return [...newRecords, ...modifiedRecords];
            },
            updateMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    ...record,
                    transType: 'U',
                }));
            }
        }
    },
    'session-details': {
        pageTitle: 'Session Details',
        breadcrumbs: [{ label: 'Court', url: '/' }, { label: 'Session Details' }],
        searchFields: [
            { key: 'name', label: 'Session Name', type: 'text' },
            { key: 'beginDate', label: 'Session Date', type: 'date' },
        ],
        masterTable: {
            panelTitle: 'Session Details',
            detailDataKey: 'panelData',
            columns: [
                {
                    key: 'name', label: 'Name', type: 'select', isEditable: true, required: true, endpoint: 'mtSession-master/get/lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'name',
                },
                { key: 'beginDate', label: 'Begin Date', type: 'date', isEditable: true, required: true },
                { key: 'endDate', label: 'End Date', type: 'date', isEditable: true, required: true },

            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Panel',
            columns: [
                {
                    key: 'name', label: 'Name', type: 'select', isEditable: false, endpoint: 'justicePanel-assign/get/lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'name',
                },
                { key: 'activeStartDate', label: 'Active Start Date', type: 'date', isEditable: true, required: true },
                { key: 'activeEndDate', label: 'Active End Date', type: 'date', isEditable: true, required: true },
            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttSession-details/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttSession-details/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttSession-details/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                // Combine new + filtered modified records
                return [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I'   // change value here
                }));;
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    id: record.id,
                    sessionId: record.sessionId,
                    description: record.description,
                    beginDate: datePipe.transform(record.beginDate, "yyyy-MM-dd'T'HH:mm:ss"),
                    endDate: datePipe.transform(record.endDate, "yyyy-MM-dd'T'HH:mm:ss"),
                    transType: "",
                    name: record.name,
                    panelId: record.panelId
                }));
            }
        }
    },

    'document-types-event-types': {
        pageTitle: 'Document Types Event Types',

        breadcrumbs: [
            { label: 'Masters', url: '/' },
            { label: 'Document Types Event Types' }
        ],

        searchFields: [
            { key: 'docTypesId', label: 'Document Type ID', type: 'number' },
            { key: 'eventId', label: 'Event Type ID', type: 'number' }
        ],

        masterTable: {
            panelTitle: 'Document Types',
            detailDataKey: 'eventTypesData',

            columns: [
                {
                    key: 'docTypesId',
                    label: 'ID',
                    type: 'select',
                    isEditable: true,
                    required: true,
                    endpoint: 'document-types/fetch-doc-types.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'docTypeId',
                    endpointLabelKey: 'docTypeId,docTypeName',
                    dependents: [
                        { sourceProperty: 'docTypeName', targetKey: 'docTypesName' }
                    ]
                },
                {
                    key: 'docTypesName',
                    label: 'Name',
                    type: 'text',
                    isEditable: false
                }
            ],

            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },

        detailTable: {
            panelTitle: 'Event Types',

            columns: [
                {
                    key: 'eventId',
                    label: 'ID',
                    type: 'select',
                    isEditable: true,
                    required: true,
                    endpoint: 'eventtypes/fetch-event-types-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'id,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'eventName' }
                    ]
                },
                {
                    key: 'eventName',
                    label: 'Name',
                    type: 'text',
                    isEditable: false
                },
                {
                    key: 'eventTypeSeq',
                    label: 'Sequence',
                    type: 'number',
                    isEditable: true,
                    required: true
                }
            ],

            actions: {
                showAdd: true
            }
        },

        apiEndpoints: {
            search: 'ttdoctypes-eventtypes/search.htm',
            searchMethod: 'GET',

            saveMaster: 'ttdoctypes-eventtypes/upsert.htm',
            saveMasterMethod: 'POST',

            deleteMaster: 'ttdoctypes-eventtypes/delete.htm',
            deleteMasterMethod: 'POST'
        },

        payloadBuilders: {

            search: (formValue: any) => {
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },

            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                const filteredModifiedRecords = modifiedRecords.filter(
                    rec => rec.transType !== 'I'
                );

                return [...newRecords, ...filteredModifiedRecords];
            },

            deleteMaster: (deletedRecords: any[]) => {

                return deletedRecords.map(record => ({
                    ...record,
                    transType: '',
                    eventId: null,
                    eventTypeSeq: null
                }));
            }
        }
    },
    'appeal-types-document-types': {
        pageTitle: 'Appeal Types Document Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Appeal Types Document Types' }],
        searchFields: [
            { key: 'caseTypesId', label: 'Court Type ID', type: 'number' },
            { key: 'docTypeId', label: 'Document Type ID', type: 'number' }
        ],
        masterTable: {
            panelTitle: 'Appeal Types',
            detailDataKey: 'docTypesData',
            detailDataRequired: true,
            columns: [
                {
                    key: 'caseTypesId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'case-types/fetch.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'id,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'caseTypesName' }
                    ]
                },
                { key: 'caseTypesName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Document Types',
            columns: [
                {
                    key: 'docTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'document-types/fetch-doc-types.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'docTypeId',
                    endpointLabelKey: 'docTypeId,docTypeName',
                    dependents: [
                        { sourceProperty: 'docTypeName', targetKey: 'docTypeName' }
                    ]
                },
                { key: 'docTypeName', label: 'Name', type: 'text', isEditable: false, },
                {
                    key: 'mandatory', label: 'Mandatory Document', type: 'select', isEditable: true, required: true, options: [{ label: 'Y', value: 'Y' },
                    { label: 'N', value: 'N' }]
                },
                {
                    key: 'checklistFlag', label: 'Checklist Document', type: 'select', isEditable: true, required: true, options: [{ label: 'Y', value: 'Y' },
                    { label: 'N', value: 'N' }]
                },


            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttcasetypes-doctypes/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttcasetypes-doctypes/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttcasetypes-doctypes/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                return [...newRecords, ...modifiedRecords];
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    caseTypesId: record.caseTypesId,
                    caseTypesName: record.caseTypesName,
                    transType: '',
                    docTypeId: record.docTypesData.length === 1 ? record.docTypesData[0].docTypeId : null
                }));
            }
        }
    },
    'appeal-status-appeal-phase-types': {
        pageTitle: 'Appeal Status Appeal phase Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Appeal Status Appeal phase Types' }],
        searchFields: [
            { key: 'appealStatusId', label: 'Appeal Status ID', type: 'number' },
            { key: 'casePhTypesId', label: 'Appeal Stage', type: 'number' }
        ],
        masterTable: {
            panelTitle: 'Appeal Status',
            detailDataKey: 'appealPhTypesData',
            detailDataRequired: true,
            columns: [
                {
                    key: 'appealStatusId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'case-status/fetch.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'caseStatusId',
                    endpointLabelKey: 'caseStatusId,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'appealStatusName' }
                    ]
                },
                { key: 'appealStatusName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Appeal Phase Types',
            columns: [
                {
                    key: 'casePhTypesId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'casephtypes/search.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'casePhTypesId',
                    endpointLabelKey: 'casePhTypesId,casePhTypesName',
                    dependents: [
                        { sourceProperty: 'casePhTypesName', targetKey: 'casePhTypesName' }
                    ]
                },
                { key: 'casePhTypesName', label: 'Name', type: 'text', isEditable: false, },


            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttappealstatus-appealphtype/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttappealstatus-appealphtype/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttappealstatus-appealphtype/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                // Combine new + filtered modified records
                return [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I'   // change value here
                }));
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                const payoad = [{
                    appealStatusId: deletedRecords[0].appealStatusId,
                    appealStatusName: deletedRecords[0].appealStatusName,
                    casePhTypesId: deletedRecords[0].appealPhTypesData[0].casePhTypesId,
                    transType: ''
                }];
                return payoad;

            }
        }
    },
    'document-types-appeal-phase-types': {
        pageTitle: 'Document Types appeal Phase Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Document Types Appeal Phase Types' }],
        searchFields: [
            { key: 'docTypeId', label: 'Document Type ID', type: 'text' },
            { key: 'appealPhaseTypeId', label: 'Appeal PhaseType ID', type: 'text' }
        ],
        masterTable: {
            panelTitle: 'Document Types',
            detailDataKey: 'appealPhTypesData',
            columns: [
                {
                    key: 'docTypeId', label: 'Document Type ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'document-types/fetch-doc-types.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'docTypeId',
                    endpointLabelKey: 'docTypeId,docTypeName',
                    dependents: [
                        { sourceProperty: 'docTypeName', targetKey: 'docTypeName' }
                    ]
                },
                { key: 'docTypeName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Appeal Phase Types',
            columns: [
                {
                    key: 'casePhTypesId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'casephtypes/search.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'casePhTypesId',
                    endpointLabelKey: 'casePhTypesId,casePhTypesName',
                    dependents: [
                        { sourceProperty: 'casePhTypesName', targetKey: 'casePhTypesName' }
                    ]
                },
                { key: 'casePhTypesName', label: 'Name', type: 'text', isEditable: false, },


            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttdoctype-casephtype/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttdoctype-casephtype/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttdoctype-casephtype/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {

                // Combine new + filtered modified records
                const payload = [...newRecords, ...modifiedRecords].map(item => ({
                    ...item,
                    transType: 'I'   // change value here
                }));

                return payload
            },
            deleteMaster: (deletedRecords: any[]) => {
                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    transType: '',
                    docTypeId: record.docTypeId,
                    docTypeName: record.docTypeName,
                    appealPhaseTypeId: deletedRecords[0].appealPhTypesData.length === 1 ? deletedRecords[0].appealPhTypesData[0].casePhTypesId : ''
                }));
            }
        }
    },
    'court-divisions-appeal-types': {
        pageTitle: 'Court Divisions Appeal Types',
        breadcrumbs: [{ label: 'Masters', url: '/' }, { label: 'Court Divisions Appeal Types' }],
        searchFields: [
            { key: 'courtUnitTypeId', label: 'Court Division ID', type: 'number' },
            { key: 'id', label: 'Appeal Type ID', type: 'number' }
        ],
        masterTable: {
            panelTitle: 'Court Divisions',
            detailDataKey: 'caseTypesData',
            columns: [
                {
                    key: 'courtUnitTypeId', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'court-unit-types/fetch-lov.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'courtUnitTypeId',
                    endpointLabelKey: 'courtUnitTypeId,courtUnitTypeName',
                    dependents: [
                        { sourceProperty: 'courtUnitTypeName', targetKey: 'courtUnitTypeName' }
                    ]
                },
                { key: 'courtUnitTypeName', label: 'Name', type: 'text', isEditable: false }
            ],
            actions: {
                showAdd: true,
                showSave: true,
                showDelete: true
            }
        },
        detailTable: {
            panelTitle: 'Appeal Types',
            columns: [
                {
                    key: 'id', label: 'ID', type: 'select', isEditable: true, required: true,
                    endpoint: 'case-types/fetch.htm',
                    endpointMethod: 'GET',
                    endpointValueKey: 'id',
                    endpointLabelKey: 'id,name',
                    dependents: [
                        { sourceProperty: 'name', targetKey: 'name' }
                    ]
                },
                { key: 'name', label: 'Name', type: 'text', isEditable: false, },
            ],
            actions: {
                showAdd: true,
            }
        },
        apiEndpoints: {
            search: 'ttcourt-unittypes-appealtype/search.htm',
            searchMethod: 'GET',

            // If backend handles both Insert/Update together
            saveMaster: 'ttcourt-unittypes-appealtype/upsert.htm',
            saveMasterMethod: 'POST',
            deleteMaster: 'ttcourt-unittypes-appealtype/delete.htm',
            deleteMasterMethod: 'POST'
        },
        payloadBuilders: {
            search: (formValue: any) => {
                // For search query params, complete search form data
                const payload = { ...formValue };
                Object.keys(payload).forEach(key => {
                    if (payload[key] === null) {
                        payload[key] = '';
                    }
                });
                return payload;
            },
            saveMaster: (newRecords: any[], modifiedRecords: any[]) => {
                // Combine and return the array of inserts and updates
                return [...newRecords, ...modifiedRecords];
            },
            deleteMaster: (deletedRecords: any[]) => {

                // Map the deleted records to the structure expected for deletion
                return deletedRecords.map(record => ({
                    courtUnitTypeId: record.courtUnitTypeId,
                    courtUnitTypeName: record.courtUnitTypeName,
                    transType: '',
                    id: record.caseTypesData.length === 1 ? record.caseTypesData[0].id : ''
                }));
            }
        }
    },
}

